export const isProd = () => !window.location.host.includes("hackledev")
